import { Injectable } from '@angular/core';
import { DeliveryStatus } from '../models/delivery.schema';
import { ApiAuthService } from './api-auth.service';

export interface PartnerActivityReminderSettingSchema {
  id?: number;
  enabled: boolean;
  reminderTime: string;
  timezone: string;
  daysAhead: number;
  statuses: DeliveryStatus[];
  partnerIds: number[];
  subject: string;
}

@Injectable({
  providedIn: 'root'
})
export class PartnerActivityReminderService extends ApiAuthService {
  private readonly url = `${this.baseUrl}/partner-activity-reminder`;

  async getSettings(): Promise<PartnerActivityReminderSettingSchema> {
    return this.request(() =>
      this.http
        .get<PartnerActivityReminderSettingSchema>(`${this.url}`)
        .toPromise(),
    );
  }

  async updateSettings(
    params: PartnerActivityReminderSettingSchema,
  ): Promise<PartnerActivityReminderSettingSchema> {
    const body = params;

    return this.request(() =>
      this.http
        .put<PartnerActivityReminderSettingSchema>(`${this.url}`, body)
        .toPromise(),
    );
  }
}
